import { whatIfInnerSelector, whatIfOptionsOrDefaultSelector } from '../../WhatIfsSelector';

export const principalStartAgeSelector = (state, props) =>
  whatIfInnerSelector(state, props).PrincipalStartAge;
export const principalDurationSelector = (state, props) =>
  whatIfInnerSelector(state, props).PrincipalDuration;
export const spouseStartAgeSelector = (state, props) =>
  whatIfInnerSelector(state, props).SpouseStartAge;
export const spouseDurationSelector = (state, props) =>
  whatIfInnerSelector(state, props).SpouseDuration;

export const principalNameSelector = (state, props) =>
  whatIfOptionsOrDefaultSelector(state, props).PrincipalName;

export const spouseNameSelector = (state, props) =>
  whatIfOptionsOrDefaultSelector(state, props).SpouseName;

export const hasSpouseSelector = (state, props) =>
  !!whatIfOptionsOrDefaultSelector(state, props).SpouseName;

export const spouseLtcStartAgeOptionsSelector = (state, props) =>
  (whatIfOptionsOrDefaultSelector(state, props).SpouseLtcStartAgeOptions || []).map(value => ({
    value,
    label: value.toString(),
  }));

export const principalLtcStartAgeOptionsSelector = (state, props) =>
  (whatIfOptionsOrDefaultSelector(state, props).PrincipalLtcStartAgeOptions || []).map(value => ({
    value,
    label: value.toString(),
  }));
export const durationOptionsSelector = (state, props) =>
  (whatIfOptionsOrDefaultSelector(state, props).DurationOptions || []).map(value => ({
    value,
    label: value.toString(),
  }));
